import "@/App.css";
import Navbar from "./site/Navbar";
import Hero from "./site/Hero";
import ClientsMarquee from "./site/ClientsMarquee";
import Services from "./site/Services";
import Process from "./site/Process";
import Portfolio from "./site/Portfolio";
import About from "./site/About";
import Pricing from "./site/Pricing";
import Testimonials from "./site/Testimonials";
import FAQ from "./site/FAQ";
import Blog from "./site/Blog";
import Contact from "./site/Contact";
import Footer from "./site/Footer";
import FloatingWhatsApp from "./site/FloatingWhatsApp";

function App() {
  return (
    <div className="App relative bg-white" data-testid="app-root">
      <Navbar />
      <main>
        <Hero />
        <ClientsMarquee />
        <Services />
        <Process />
        <Portfolio />
        <About />
        <Pricing />
        <Testimonials />
        <FAQ />
        <Blog />
        <Contact />
      </main>
      <Footer />
      <FloatingWhatsApp />
    </div>
  );
}

export default App;
